const productsTab = {
  'Potencia tu búsqueda': 'Potencia tu búsqueda',
  '¡Potencia tu búsqueda y aumenta las chances de que te elijan!':
    '¡Potencia tu búsqueda y aumenta las chances de que te elijan!',
}

export default productsTab
